module.exports = __webpack_public_path__ + "img/b_3.bfc47626.jpg";